import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST } from './../_getjson';
import { CreditCode } from "./../PopUp/PopUpOther"
import PopUpCsConfirm from "./PopUpCsConfirm";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button, Modal } from "react-bootstrap";
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import axios from 'axios'
require('./../_css/PopUpOther.css');
export default class PopUpCloseSublist extends React.Component {
    constructor(props) {
        super(props);
        this.Docdate = React.createRef();
        this.Docnumber = React.createRef();
        this.Code = React.createRef();
        this.Typeprice = React.createRef();
        this.Shipment = React.createRef();
        this.Creditcode = React.createRef();
        this.Delivery = React.createRef();
        this.Currency = React.createRef();
        this.Exrate = React.createRef();
        this.Csname = React.createRef();
        this.Annotation1 = React.createRef();
        this.Annotation2 = React.createRef();
        this.Groupdata_name = React.createRef();
        this.Groupdata = React.createRef();
        this.state = {
            col: [],
            rows: [],
            valueRetuen: "",
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
            docno: "",
            Groupdata: "",
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: ""
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event, data) => {
        console.log(event, data);
        var dataArray = [];
        var code = ""
        if (event === "true") {
            code = "&docno=" + this.state.docno
        } else {
            code = "&docno=" + this.Code.current.value
        }

        var Url = "CSV_SALEREFDOCNO3/getsubdocno?arcode=" + this.props.ARCODE + code;
        console.log(genURL(Url));
        axios.get(genURL(Url), { timeout: 3600 }).then(res => {
            var j = 0;
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[j] = {
                        number: i + 1,
                        T_PRODUCTCODE: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        T_: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].ISSQTY,
                        Col6: res.data[i].ISSREM,
                        Col7: res.data[i].SHIPQTY,
                        Col8: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col12: res.data[i].SHIPREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        SB: "0",
                    }
                    j++;
                }

                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
        this.setState({ rows: this.state.rows });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        let data = this.props.data
        console.log(data);
        this.SetInput(data)
        this.SetRow()
        this.SetTable(data.T_Queue)
    }

    SetTable = (docno) => {
        var Url = "CC_SaleOrder/Seleordersub?Docno=" + docno;
        var dataArray = [];
        console.log(genURL(Url));
        axios.get(genURL(Url), { timeout: 3600 }).then(res => {
            var j = 0;
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[j] = {
                        N: i + 1,
                        T_PRODUCTCODE: res.data[i].PRODUCTCODE,
                        T_PRODUCTNAME: res.data[i].PRODUCTNAME,
                        T_WAREHOUSE: res.data[i].WAREHOUSE,
                        T_UNITCODE: res.data[i].UNITCODE,
                        T_QUANTITY: res.data[i].QUANTITY,
                        T_REMAINQTY: res.data[i].REMAINQTY,
                        T_UNITPRICE: res.data[i].UNITPRICE,
                        T_EXTAMOUNT: res.data[i].EXTAMOUNT,
                        T_UNITCOST: res.data[i].UNITCOST,
                        T_LINEID: res.data[i].LINEID,
                        SB: "0",
                    }
                    j++;
                }
                this.setState({ rows: dataArray });
            } else {
                this.setState({ rows: dataArray });
            }
        });
    }
    SetInput = (data) => {
        this.Docdate.current.value = data.T_Date
        this.Docnumber.current.value = data.T_Queue
        this.Typeprice.current.value = this.Convert(data.taxtype)
        this.Shipment.current.value = ""
        this.Creditcode.current.value = data.creditcode + "-" + CreditCode(data.creditcode)
        this.setState({ Creditcode: data.creditcode + "-" + CreditCode(data.creditcode) })
        this.Delivery.current.value = ""
        this.Currency.current.value = data.currencycode + "-" + data.T_Currency
        this.setState({ Currency: data.currencycode + "-" + data.T_Currency })
        this.Exrate.current.value = data.exchangerate
        this.Csname.current.value = data.T_Name
        this.Annotation1.current.value = data.T_Remark
        this.Annotation2.current.value = ""
    }
    Convert = (type) => {
        let taxtype = ""
        switch (type) {
            case 0:
                taxtype = "ราคาไม่รวมภาษี"
                break;
            case 1:
                taxtype = "ราคารวมภาษี"
                break;
            case 2:
                taxtype = "ภาษีอัตราศูนย์"
                break;

            default:
                break;
        }
        return taxtype
    }

    SetRow = () => {
        var data = [];
        for (var i = 0; i <= 10 - 1; i++) {
            data[i] = { N: i + 1 };
        }
        this.setState({ rows: data });
    };
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].T_PRODUCTCODE; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].T_PRODUCTCODE; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            var dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }

    onSelectRow = (data, col, id, row) => {
        this.setState({ valueRetuen: data.code });

        if (col > 1 && data.T_PRODUCTCODE !== undefined) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            this.setState({ T_PRODUCTCODE: data.T_PRODUCTCODE });
            console.log(data.T_PRODUCTCODE);
            //------------------------
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].T_PRODUCTCODE; i++) {
                console.log(this.state.rows[i].SB);
                if (this.state.rows[i].SB === "1") {
                    reData[j] = {
                        T_PRODUCTCODE: this.state.rows[i].T_PRODUCTCODE,
                        Col2: this.state.rows[i].Col2,
                        T_: this.state.rows[i].T_,
                        Col4: this.state.rows[i].Col4,
                        Col5: this.state.rows[i].Col5,
                        Col6: this.state.rows[i].Col6,
                        Col7: this.state.rows[i].Col7,
                        Col8: this.state.rows[i].Col8,
                        Col9: this.state.rows[i].Col9,
                        Col10: this.state.rows[i].Col10,
                        Col11: this.state.rows[i].Col11,
                        Col12: this.state.rows[i].Col12,
                        Col13: this.state.rows[i].Col13,
                        Col14: this.state.rows[i].Col14,
                        _unitCode: this.state.rows[i]._unitCode,
                        _refLineID: this.state.rows[i]._refLineID,
                    }
                    j++
                }
            }
            /* console.log(reData.length); */
            if (reData.length !== 0) {
                this.props.Get_PopUpSelSaleRef3Sub(reData);
            }
        }
    }
    onSubmit = () => {
        var Lineid = "";
        let Code = this.Groupdata_name.current.value
        var Docno = this.Docnumber.current.value
        var row = this.state.rows
        console.log(row);
        if (Code === "" || this.Groupdata.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาระบุสาเหตุ" })
            return
        }

        for (var i = 0; i < row.length; i++) {
            console.log(row[i].SB);
            if (row[i].SB === "1") {
                if (row[i].T_LINEID !== "") {
                    Lineid += "&Lineid=" + row[i].T_LINEID;
                }
                if (row[i].T_LINEID === "" && i === 0) {
                    Lineid += "&Lineid=" + i + 1
                }
                if (row[i].T_LINEID === "" && i < 0) {
                    Lineid += "&Lineid=" + i
                }
            }
        }
        console.log(Lineid, "5555");
        if (Lineid === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกข้อมูล" })
            return
        } else {
            this.setState({ show1: true })
            var Url = "CC_SaleOrder/Save?Code=" + Code + "&Docno=" + Docno + Lineid;
            console.log(Url);
            this.setState({ Url: Url })
        }
    };
    Confirm = () => {
        this.setState({ CsConfirm: !this.state.CsConfirm })
    }
    Closelist = () => {
        this.setState({ openBackdrop: true })
        let Url = this.state.Url;
        // let Docno = this.Docnumber.current.value;
        //axios.get(genURL(Url), { timeout: 3600 }).then(res => {
        axios.post(genpostURL(Url)).then(res => {
            if (res.data === "1") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "success" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "บันทึกข้อมูลสำเร็จ" })
                this.setState({ openBackdrop: false })
                setTimeout(() => {
                    // this.SetTable(Docno)
                    this.props.Getdata()
                }, 3000);
            }
            else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "บันทึกข้อมูลสำไม่สำเร็จ" })
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            this.setState({ openBackdrop: false })
        });
    }
    onChange = (e) => {
        if (e.target.value === "") {
            this.Groupdata_name.current.value = ""
            this.Groupdata.current.value = ""
            this.setState({ Groupdata: "" })
        }
    }
    KeyConfirm = (e) => {
        if (e.key === 'Enter') {
            var Url = "CC_SaleOrder/Confirm?Code=" + e.target.value
            console.log(genURL(Url));
            axios.get(genURL(Url), { timeout: 3600 }).then(res => {
                if (res.data.length > 0) {
                    console.log(res.data);
                    this.Groupdata_name.current.value = res.data[0].CODE
                    this.Groupdata.current.value = res.data[0].CODE + "-" + res.data[0].MYNAMETH
                    this.setState({ Groupdata: res.data[0].CODE + "-" + res.data[0].MYNAMETH })
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    this.Groupdata_name.current.value = ""
                    this.Groupdata.current.value = ""
                    this.setState({ Groupdata: "" })
                }

            })
        }
    }
    PopUpConfirm = () => {
        this.setState({ CsConfirm: !this.state.CsConfirm })
    }
    Get_PopUpConfirm = (data) => {
        this.Groupdata_name.current.value = data[0].ArCode
        this.Groupdata.current.value = data[0].ArCode + "-" + data[0].Description
        this.setState({ Groupdata: data[0].ArCode + "-" + data[0].Description })
        this.setState({ CsConfirm: !this.state.CsConfirm })
    }
    render() {
        return (

            <div className='popup' >
                <Backdrop open={this.state.openBackdrop} />
                {this.state.CsConfirm ? (<PopUpCsConfirm closePopup={this.PopUpConfirm} Get_PopUpConfirm={this.Get_PopUpConfirm} />) : null}
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1">
                            <i className="fas fa-search"> ปิดรายการย่อยใบสั่งขายสินค้า(CC_SaleOrderSub)</i>
                        </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i className="fas fa-times"></i>
                        </div>
                    </div>
                    <style jsx>{`
                        input.form-control.white {
                            background-color: white;
                        }
                    `}</style>
                    <div className="panel-body divTable" align="right">
                        <div className="row">
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">วันที่เอกสาร : </span>
                                    <input type="text" className="form-control white" ref={this.Docdate} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">เลขที่เอกสาร : </span>
                                    <input type="text" className="form-control white" ref={this.Docnumber} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ประเภทราคา : </span>
                                    <input type="text" className="form-control white" ref={this.Typeprice} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">การส่งมอบ : </span>
                                    <input type="text" className="form-control white" ref={this.Shipment} disabled />
                                    <span id="iconTaxNumber" className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">รหัสเครดิต : </span>
                                    <input type="text" className="form-control white" ref={this.Creditcode} onMouseOver={(e) => { e.target.value = this.props.data.creditcode }}
                                        onMouseOut={(e) => { e.target.value = this.state.Creditcode }} disabled />
                                    <span className="input-group-addon icon" ></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">นัดส่งมอบ : </span>
                                    <input type="text" className="form-control white" ref={this.Delivery} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">สกุลเงิน : </span>
                                    <input type="text" className="form-control white" ref={this.Currency} onMouseOver={(e) => { e.target.value = this.props.data.currencycode }}
                                        onMouseOut={(e) => { e.target.value = this.state.Currency }} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">อัตราแลกเปลี่ยน : </span>
                                    <input type="text" className="form-control white" ref={this.Exrate} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">ชื่อลูกค้า : </span>
                                    <input type="text" className="form-control white" ref={this.Csname} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">หมายเหตุ : </span>
                                    <input type="text" className="form-control white" ref={this.Annotation1} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                            <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon">หมายเหตุ2 : </span>
                                    <input type="text" className="form-control white" ref={this.Annotation2} disabled />
                                    <span className="input-group-addon icon"></span>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid" style={{ backgroundColor: "rgba(190, 200, 215, 0.9)", marginTop: "8px", height: "40px" }}>
                            <div className="row">
                                <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4" >
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon">สาเหตุ : </span>
                                        <input type="text" className="form-control hidden" ref={this.Groupdata_name} />
                                        <input type="text" className="form-control" ref={this.Groupdata} onKeyDown={this.KeyConfirm} onClick={(e) => e.target.value = this.Groupdata_name.current.value}
                                            onBlur={(e) => e.target.value = this.state.Groupdata}
                                            onChange={this.onChange} />
                                        <span className="input-group-addon icon" onClick={this.Confirm} >{<i className="fas fa-search"></i>}</span>
                                    </div>
                                </div>
                                <div className="form-group col-xs-2 col-sm-2 col-lg-2 col-md-2" style={{ width: "5%", marginTop: "5px" }} >
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <button className="secondary" >
                                            <i className="fas "> ... </i>
                                        </button>
                                    </div>
                                </div>
                                <div className="form-group col-xs-3 col-sm-3 col-lg-3 col-md-3" style={{ textAlign: "left", marginTop: "5px" }}>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <button className="secondary" onClick={this.onSubmit} style={{ fontWeight: "bolder", height: "30px" }}>
                                            ประมวลผล
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div >
                                <Modal show={this.state.show1} size="sm" /*กดข้างนอก Modal onHide={() => { this.setState({ show1: false }) }}  */ >
                                    <Modal.Header style={{ backgroundColor: 'rgba(190, 200, 215, 0.9)', borderRadius: '10px 10px 0px 0px' }}>
                                        <div className="PopUpOtherDivH1"><i className="fas " style={{ color: 'white' }}> ปิดรายการ </i></div>
                                        <div className="PopUpOtherDivH2"><i className="fas fa-times" style={{ color: 'white' }} onClick={() => { this.setState({ show1: false }) }}></i></div>
                                    </Modal.Header>
                                    <Modal.Body style={{ fontSize: '20px', left: '12px' }}>คุณต้องการปิดรายการ ใช่หรือไม่! </Modal.Body>
                                    <Modal.Footer style={{ backgroundColor: 'rgba(190, 200, 215, 0.9)', borderRadius: '0px 0px 10px 10px' }}>
                                        <Button variant="secondary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={() => { this.Closelist(); this.setState({ show1: false }) }}> ใช่ </Button>
                                        <Button variant="primary" style={{ width: '60px', height: '36px', fontSize: '20px' }} onClick={() => { this.setState({ show1: false }) }}> ไม่ใช่ </Button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </div>
                        <div style={{ marginTop: "10px" }} >
                            <BootstrapTable
                                data={this.state.rows}
                                /* options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา" }} */
                                height="500"
                                hover condensed
                            >
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="35" dataField='N' isKey  ></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i className={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='T_PRODUCTCODE' > รหัส </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="300" dataField='T_PRODUCTNAME' > ชื่อสินค้า</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_WAREHOUSE' > คลัง</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_UNITCODE' > หน่วย</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_' > หมายเหตุ</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_QUANTITY' > ปริมาณ</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_REMAINQTY' > ค้าง</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_UNITPRICE' > ราคาขาย</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_' > ลด</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_EXTAMOUNT' > จำนวนเงิน</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_UNITCOST' > ต้นทุน</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_' > พนักงาน</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_' > รายการขายล่าสุด</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_' > ส่วนลดล่าสุด</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='T_LINEID' hidden > LINEID</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
            </div>
        );
    }
}